// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JHb7W","buttonDark":"Button_buttonDark__DnLzB","buttonWhite":"Button_buttonWhite__VC807","buttonDisabled":"Button_buttonDisabled__MgHyX"};